import { Trans } from "@lingui/react/macro";
import { Loader2 } from "lucide-react";
import type * as React from "react";

/** Inline loading row (spinner + label). */
export function HmLoading({ label }: { label: React.ReactNode }): React.ReactElement {
  return (
    <div className="flex items-center gap-2 py-12 text-ink-3">
      <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
      <span className="text-sm">{label}</span>
    </div>
  );
}

/** Error banner (pencil hairline contour) with optional retry. */
export function HmError({
  message,
  onRetry,
}: { message: React.ReactNode; onRetry?: () => void }): React.ReactElement {
  return (
    <div className="rounded-xl border border-red-300/70 bg-transparent p-4 text-red-700 text-sm">
      <p>{message}</p>
      {onRetry ? (
        <button type="button" onClick={onRetry} className="mt-2 font-medium underline">
          <Trans>Riprova</Trans>
        </button>
      ) : null}
    </div>
  );
}

/** Empty state (icon + label) on a hairline cream card. */
export function HmEmpty({
  icon,
  label,
}: { icon?: React.ReactNode; label: React.ReactNode }): React.ReactElement {
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-xl border border-hairline bg-cream/40 py-12 text-center text-ink-3">
      {icon}
      <p className="text-sm">{label}</p>
    </div>
  );
}
